export const ZeroStorageReasonList = (
  <ul>
    <li>The storage hasn't been scanned yet</li>
    <li>The data is streamed from external sources</li>
    <li>The data layers are already counted in other (linked) datasets</li>
    <li>The dataset belongs to another organization</li>
    <li>The dataset is empty</li>
  </ul>
);
